module.exports = __webpack_public_path__ + "img/gnv.2a7e6dcd.jpg";